import { BrandKitFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/brand-kit/catalog";
import { BrandKitFlatTeamSettingGroups } from "../../flat-team-settings/brand-kit/groups";
import { ContextualFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/contextual/catalog";
import { ContextualFlatTeamSettingGroups } from "../../flat-team-settings/contextual/groups";
import { CoverageFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/coverage/catalog";
import { CoverageFlatTeamSettingGroups } from "../../flat-team-settings/coverage/groups";
import { CustomerAccountsAdBlocksEditFlatTeamSettingGroups } from "../../flat-team-settings/customer-accounts-ad-blocks-edit/groups";
import { CustomerAccountsAdBlocksFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/customer-accounts-ad-blocks/catalog";
import { CustomerAccountsAdBlocksFlatTeamSettingGroups } from "../../flat-team-settings/customer-accounts-ad-blocks/groups";
import { CustomerAccountsStorefrontDisplayFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/customer-accounts-storefront-display/catalog";
import { CustomerAccountsStorefrontDisplayFlatTeamSettingGroups } from "../../flat-team-settings/customer-accounts-storefront-display/groups";
import { CustomerPortalAbTestAnalyticsFlatTeamSettingGroups } from "../../flat-team-settings/customer-portal-ab-test-analytics/groups";
import { CustomerPortalBundlesFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/customer-portal-bundles/catalog";
import { CustomerPortalBundlesFlatTeamSettingGroups } from "../../flat-team-settings/customer-portal-bundles/groups";
import { CustomerPortalFlowEditorsFlatTeamSettingGroups } from "../../flat-team-settings/customer-portal-flow-editors/groups";
import { CustomerPortalFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/customer-portal/catalog";
import { CustomerPortalFlatTeamSettingGroups } from "../../flat-team-settings/customer-portal/groups";
import { CustomerWidgetFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/customer-widget/catalog";
import { CustomerWidgetFlatTeamSettingGroups } from "../../flat-team-settings/customer-widget/groups";
import { ExchangeAgentGuidanceFlatTeamSettingGroups } from "../../flat-team-settings/exchange-agent-guidance/groups";
import { FulfillmentFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/fulfillment/catalog";
import { FulfillmentFlatTeamSettingGroups } from "../../flat-team-settings/fulfillment/groups";
import { HsaFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/hsa/catalog";
import { HsaFlatTeamSettingGroups } from "../../flat-team-settings/hsa/groups";
import { InternationalCustomsFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/international-customs/catalog";
import { InternationalCustomsFlatTeamSettingGroups } from "../../flat-team-settings/international-customs/groups";
import { InternationalMarketsEditorFlatTeamSettingGroups } from "../../flat-team-settings/international-markets-editor/groups";
import { InternationalMarketsFlatTeamSettingGroups } from "../../flat-team-settings/international-markets/groups";
import { InternationalReturnsFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/international-returns/catalog";
import { InternationalReturnsFlatTeamSettingGroups } from "../../flat-team-settings/international-returns/groups";
import { InventoryGeneralFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/inventory-general/catalog";
import { InventoryGeneralFlatTeamSettingGroups } from "../../flat-team-settings/inventory-general/groups";
import { InventoryPurchaseOrdersFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/inventory-purchase-orders/catalog";
import { InventoryPurchaseOrdersFlatTeamSettingGroups } from "../../flat-team-settings/inventory-purchase-orders/groups";
import { InventoryQuickbooksAccountMappingFlatTeamSettingGroups } from "../../flat-team-settings/inventory-quickbooks-account-mapping/groups";
import { InventoryQuickbooksFlatTeamSettingGroups } from "../../flat-team-settings/inventory-quickbooks/groups";
import { OrderTrackingSettingsFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/order-tracking-settings/catalog";
import { OrderTrackingSettingsFlatTeamSettingGroups } from "../../flat-team-settings/order-tracking-settings/groups";
import { PortalBuilderFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/portal-builder/catalog";
import { PortalBuilderFlatTeamSettingGroups } from "../../flat-team-settings/portal-builder/groups";
import { ProductsAttributesByOwnerFlatTeamSettingGroups } from "../../flat-team-settings/products-attributes-by-owner/groups";
import { ProductsAttributesFlatTeamSettingGroups } from "../../flat-team-settings/products-attributes/groups";
import { ProductsGeneralFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/products-general/catalog";
import { ProductsGeneralFlatTeamSettingGroups } from "../../flat-team-settings/products-general/groups";
import { ReturnsBillingGeneralFlatTeamSettingGroups } from "../../flat-team-settings/returns-billing-general/groups";
import { ReturnsFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/returns/catalog";
import { ReturnsFlatTeamSettingGroups } from "../../flat-team-settings/returns/groups";
import { ShippingCarriersFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/shipping-carriers/catalog";
import { ShippingCarriersFlatTeamSettingGroups } from "../../flat-team-settings/shipping-carriers/groups";
import { ShippingCrossBorderFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/shipping-cross-border/catalog";
import { ShippingCrossBorderFlatTeamSettingGroups } from "../../flat-team-settings/shipping-cross-border/groups";
import { ShippingDiscountsFlatTeamSettingGroups } from "../../flat-team-settings/shipping-discounts/groups";
import { ShippingFreightFlatTeamSettingGroups } from "../../flat-team-settings/shipping-freight/groups";
import { ShippingFulfillmentPromiseFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/shipping-fulfillment-promise/catalog";
import { ShippingFulfillmentPromiseFlatTeamSettingGroups } from "../../flat-team-settings/shipping-fulfillment-promise/groups";
import { SupportFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/support/catalog";
import { SupportFlatTeamSettingGroups } from "../../flat-team-settings/support/groups";
import { WarrantyRegistrationRewardsFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/warranty-registration-rewards/catalog";
import { WarrantyRegistrationRewardsFlatTeamSettingGroups } from "../../flat-team-settings/warranty-registration-rewards/groups";
import { WarrantyRegistrationFlatTeamSettingCatalogDefinitions } from "../../flat-team-settings/warranty-registration/catalog";
import { WarrantyRegistrationFlatTeamSettingGroups } from "../../flat-team-settings/warranty-registration/groups";
import { defineSettingsProvider } from "../provider";
import type { SettingDefinition, SettingGroupDefinition } from "../types";

export const FlatTeamSettingsCatalogProvider = defineSettingsProvider({
  name: "flat team settings",
  groups: [
    ...CustomerWidgetFlatTeamSettingGroups,
    ...HsaFlatTeamSettingGroups,
    ...FulfillmentFlatTeamSettingGroups,
    ...BrandKitFlatTeamSettingGroups,
    ...ContextualFlatTeamSettingGroups,
    ...ReturnsFlatTeamSettingGroups,
    ...SupportFlatTeamSettingGroups,
    ...ExchangeAgentGuidanceFlatTeamSettingGroups,
    ...ReturnsBillingGeneralFlatTeamSettingGroups,
    ...WarrantyRegistrationFlatTeamSettingGroups,
    ...WarrantyRegistrationRewardsFlatTeamSettingGroups,
    ...CoverageFlatTeamSettingGroups,
    ...CustomerAccountsStorefrontDisplayFlatTeamSettingGroups,
    ...CustomerAccountsAdBlocksFlatTeamSettingGroups,
    ...CustomerAccountsAdBlocksEditFlatTeamSettingGroups,
    ...CustomerPortalBundlesFlatTeamSettingGroups,
    ...CustomerPortalFlowEditorsFlatTeamSettingGroups,
    ...CustomerPortalAbTestAnalyticsFlatTeamSettingGroups,
    ...PortalBuilderFlatTeamSettingGroups,
    ...CustomerPortalFlatTeamSettingGroups,
    ...OrderTrackingSettingsFlatTeamSettingGroups,
    ...InternationalCustomsFlatTeamSettingGroups,
    ...InternationalMarketsFlatTeamSettingGroups,
    ...InternationalMarketsEditorFlatTeamSettingGroups,
    ...InternationalReturnsFlatTeamSettingGroups,
    ...ProductsGeneralFlatTeamSettingGroups,
    ...ProductsAttributesFlatTeamSettingGroups,
    ...ProductsAttributesByOwnerFlatTeamSettingGroups,
    ...InventoryGeneralFlatTeamSettingGroups,
    ...InventoryPurchaseOrdersFlatTeamSettingGroups,
    ...InventoryQuickbooksFlatTeamSettingGroups,
    ...InventoryQuickbooksAccountMappingFlatTeamSettingGroups,
    ...ShippingCrossBorderFlatTeamSettingGroups,
    ...ShippingFulfillmentPromiseFlatTeamSettingGroups,
    ...ShippingCarriersFlatTeamSettingGroups,
    ...ShippingDiscountsFlatTeamSettingGroups,
    ...ShippingFreightFlatTeamSettingGroups,
  ],
  definitions: [
    ...CustomerWidgetFlatTeamSettingCatalogDefinitions,
    ...HsaFlatTeamSettingCatalogDefinitions,
    ...FulfillmentFlatTeamSettingCatalogDefinitions,
    ...BrandKitFlatTeamSettingCatalogDefinitions,
    ...ContextualFlatTeamSettingCatalogDefinitions,
    ...ReturnsFlatTeamSettingCatalogDefinitions,
    ...SupportFlatTeamSettingCatalogDefinitions,
    ...WarrantyRegistrationFlatTeamSettingCatalogDefinitions,
    ...WarrantyRegistrationRewardsFlatTeamSettingCatalogDefinitions,
    ...CoverageFlatTeamSettingCatalogDefinitions,
    ...CustomerAccountsStorefrontDisplayFlatTeamSettingCatalogDefinitions,
    ...CustomerAccountsAdBlocksFlatTeamSettingCatalogDefinitions,
    ...CustomerPortalBundlesFlatTeamSettingCatalogDefinitions,
    ...PortalBuilderFlatTeamSettingCatalogDefinitions,
    ...CustomerPortalFlatTeamSettingCatalogDefinitions,
    ...OrderTrackingSettingsFlatTeamSettingCatalogDefinitions,
    ...InternationalCustomsFlatTeamSettingCatalogDefinitions,
    ...InternationalReturnsFlatTeamSettingCatalogDefinitions,
    ...ProductsGeneralFlatTeamSettingCatalogDefinitions,
    ...InventoryGeneralFlatTeamSettingCatalogDefinitions,
    ...InventoryPurchaseOrdersFlatTeamSettingCatalogDefinitions,
    ...ShippingCrossBorderFlatTeamSettingCatalogDefinitions,
    ...ShippingFulfillmentPromiseFlatTeamSettingCatalogDefinitions,
    ...ShippingCarriersFlatTeamSettingCatalogDefinitions,
  ],
});

export const FlatTeamSettingsCatalogGroups =
  FlatTeamSettingsCatalogProvider.groups satisfies readonly SettingGroupDefinition[];

export const FlatTeamSettingsCatalogDefinitions =
  FlatTeamSettingsCatalogProvider.definitions satisfies readonly SettingDefinition[];
